import { useLocation } from "react-router-dom";

import { ROUTES } from "../../routes";

export const useIsPastReportPage = (): boolean => {
  const location = useLocation();
  return location.pathname.includes(ROUTES.Dashboard.PastReports.path);
};
